import { render, staticRenderFns } from "./SysRole.vue?vue&type=template&id=6c8e7cec&scoped=true"
import script from "./SysRole.vue?vue&type=script&lang=js"
export * from "./SysRole.vue?vue&type=script&lang=js"
import style0 from "./SysRole.vue?vue&type=style&index=0&id=6c8e7cec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8e7cec",
  null
  
)

export default component.exports